module.exports = __webpack_public_path__ + "static/media/Knight of the Yellow Castle.69a69f9c.jpg";